"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowInfoTab = void 0;
const react_1 = __importDefault(require("react"));
const use_query_params_1 = require("use-query-params");
const core_1 = require("@material-ui/core");
const WorkflowInfoCard_1 = __importDefault(require("../cards/WorkflowInfoCard"));
const WorkflowStatusCard_1 = __importDefault(require("../cards/WorkflowStatusCard"));
const WorkflowVersionCard_1 = __importDefault(require("../cards/WorkflowVersionCard"));
const WorkflowBuilderContext_1 = require("../WorkflowBuilderContext");
const WorkflowInfoTab = props => {
    const { workflow, onChange } = props;
    const [includeDeleted] = (0, use_query_params_1.useQueryParam)('deleted', (0, use_query_params_1.withDefault)(use_query_params_1.BooleanParam, false));
    const { findWorkflows } = (0, WorkflowBuilderContext_1.useWorkflowBuilderContext)();
    return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 8 },
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(WorkflowInfoCard_1.default, { workflow: workflow, onChange: updated => {
                            onChange === null || onChange === void 0 ? void 0 : onChange(updated);
                            // refresh list on update workflow
                            findWorkflows({ includeDeleted });
                        } })))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 4 },
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(WorkflowStatusCard_1.default, { workflow: workflow })),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(WorkflowVersionCard_1.default, { workflow: workflow }))))));
};
exports.WorkflowInfoTab = WorkflowInfoTab;
exports.default = exports.WorkflowInfoTab;
//# sourceMappingURL=WorkflowInfoTab.js.map